var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71252 2.31914L4.19418 5.92164C2.42502 7.07664 2.42502 9.66164 4.19418 10.8166L9.71252 14.4191C10.7025 15.07 12.3342 15.07 13.3242 14.4191L18.815 10.8166C20.575 9.66164 20.575 7.0858 18.815 5.9308L13.3242 2.32831C12.3342 1.66831 10.7025 1.66831 9.71252 2.31914Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66078 11.99L5.65161 16.2892C5.65161 17.4533 6.54994 18.7 7.64994 19.0667L10.5741 20.0383C11.0783 20.2033 11.9124 20.2033 12.4258 20.0383L15.3499 19.0667C16.4499 18.7 17.3483 17.4533 17.3483 16.2892V12.0358",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1167 13.75V8.25",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.42aa9547e01a5882216fa065c6a55b33.svg";
export { ForwardRef as ReactComponent };